import { render, staticRenderFns } from "./DataLoadFilter.vue?vue&type=template&id=63a1a5af&scoped=true&"
import script from "./DataLoadFilter.vue?vue&type=script&lang=js&"
export * from "./DataLoadFilter.vue?vue&type=script&lang=js&"
import style0 from "./DataLoadFilter.vue?vue&type=style&index=0&id=63a1a5af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a1a5af",
  null
  
)

export default component.exports